import {GET_GROUP_POST_CYCLE_START} from "../../types";

export const group_posts_cycle = (payload) => ({
    type: GET_GROUP_POST_CYCLE_START,
    payload,
});
